import { all, call } from 'redux-saga/effects';
import { onQueryDownloadIds } from './queryDownloadIds';

export default function* directDownloadSaga() {
  yield all([call(onQueryDownloadIds)]);
}
